import { render, staticRenderFns } from "./commonReportInfo.vue?vue&type=template&id=2be27f6a"
import script from "./commonReportInfo.vue?vue&type=script&lang=js"
export * from "./commonReportInfo.vue?vue&type=script&lang=js"
import style0 from "./commonReportInfo.vue?vue&type=style&index=0&id=2be27f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports